<template>
  <component
    :is="isMagnoliaEdit || !isLink ? 'span' : NuxtLink"
    ref="downloadLinkRef"
    :class="[
      { 'cursor-pointer': isLink, 'stretched-link': isLink && stretchLink },
      isLink ? optionalLinkClasses : '',
      link?.style ? contentToTailwindClasses({ btnStyle: link?.style }) : '',
    ]"
    :download="isDownload || null"
    :external="(isLink && !isInternal) || null"
    :target="optionTarget || null"
    :to="optionHref"
    @click="onClick"
  >
    <slot />
  </component>
</template>

<script setup>
import { computed, unref } from "vue";
import { getId, isDownloadLink, linkOptionHref, linkOptionTarget } from "~/utils/helper/magnolia";
import NuxtLink from "#app/components/nuxt-link";
import useDownloadTracking from "~/composables/tracking/useDownloadTracking";
import { contentToTailwindClasses } from "~/utils/helper/tailwind";

const props = defineProps(["link", "target", "href", "optionalLinkClasses", "stretchLink"]);

const { trackNavigation } = useNavigationTracking();
const { trackDownload } = useDownloadTracking();
const { isMagnoliaEdit } = useMagnoliaContext();

const downloadLinkRef = ref(null);
const isLink = computed(() => !!optionHref.value);
const isDownload = computed(() => isDownloadLink(props.link));
const isInternal = computed(() => isLink.value && props?.link?.type === "intern");

const optionHref = computed(() => linkOptionHref(props?.link) || props?.href);
const optionTarget = computed(() =>
  unref(isLink) ? linkOptionTarget(props?.link) || props?.target || "_self" : "",
);

const onClick = () => {
  if (isLink.value) {
    trackNavigation(props.link?.label ?? getId(props.link));
  }
  if (isDownload.value) {
    trackDownload(props.link, downloadLinkRef);
  }
};
</script>
